import { path, isEmpty, pick } from 'ramda';
import qs from 'qs';

export const getUtm = () => {
    const search = path(['location', 'search'], window);
    const params = qs.parse(`${search || ''}`.replace('?', ''));
    const utm = pick(['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_tool'], params);

    return qs.stringify(utm);
};

export const getUtmFromSearch = search => {
    const params = qs.parse(`${search || ''}`.replace('?', ''));
    const utm = pick(['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_tool'], params);

    return isEmpty(utm) ? { tool: 'landing' } : {
        source: utm.utm_source,
        medium: utm.utm_medium,
        campaign: utm.utm_campaign,
        term: utm.utm_term,
        content: utm.utm_content,
        tool: utm.utm_tool || 'landing',
    };
};

export const getUtmTool = vacancy => {
    return `${path(['location', 'origin'], window)}${path(['location', 'pathname'], window)}`;
};
